import { Box, Typography, Container, Button } from '@mui/material';
import { detailLocationMap, getLocation } from 'redux-api/slices/locationMapSlice';
import ReactMapGl, { Marker } from 'react-map-gl';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Mark } from 'assets/icons/marker.svg';
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
import { REQUEST_STATUSES } from 'common/constants';
import Loader from 'components/Loader/Loader';
// eslint-disable-next-line import/no-webpack-loader-syntax
import classes from './LocationMap.module.scss';


// style for map
const styleMap = 'mapbox://styles/mratick/clgup5gmm005g01pg32w6gcfg';

// token for map
const token = 'pk.eyJ1IjoibXJhdGljayIsImEiOiJjbGd1cDlxZHMxNm5vM2ZsOGw3M2ZwNWVuIn0.mzMU9BGHqb7NllTf1TmPeA';

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;


const LocationMap = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getLocation());
  }, [ dispatch ]);

  const { location, locationStatus } = useSelector(detailLocationMap);

  const [ activeButton, setActiveButton ] = useState(0);

  const [ options, setOptions ] = useState({
    latitude: 42.90071019998644,
    longitude: 74.5936226263244,
    zoom: 10,
  });

  const generateContent = (arrayLocation) => {
    if (arrayLocation) {
      return arrayLocation.map((item, i) => {
        const keys = Object.keys(item);
        return (<li className={classes.liMap} key={i}>{item[ keys ]}</li>);
      });
    }
  };

  const onChange = (e) => {
    const { latitude, longitude, zoom } = e.viewState;
    setOptions({ latitude, longitude, zoom: zoom || 12 });
  };
  if (locationStatus !== REQUEST_STATUSES.SUCCEEDED) return null;
  return (
    <Box className={classes.map}>
      <Container>
        { locationStatus === REQUEST_STATUSES.REQUESTED
          ?
          <Loader/>
          :
          <Box className={classes.mapContainer}>
            <Box className={classes.mapCard}>
              <Typography className={classes.cardTitle}>{t('Contacts')}</Typography>
              <Box className={classes.buttonsMap}>
                {location?.map((item, i) => (
                  <Button
                    key={i}
                    onClick={() => {
                      setActiveButton(i);
                      setOptions({
                        latitude: item.point[ 0 ].latitude,
                        longitude: item.point[ 0 ].longitude
                      });
                    }}
                    className={activeButton === i ? classes.yellowButton : classes.defaultButton}
                  >
                    {item.city}
                  </Button>
                )
                )}
              </Box>
              <Box className={classes.locationContent}>
                <Typography className={classes.cardTitleMini}>{t('PhoneNumber')}</Typography>
                <ul>{generateContent(location[ activeButton ]?.phones)}</ul>
                <Typography className={classes.cardTitleMini}>{t('Email')}</Typography>
                <ul>{generateContent(location[ activeButton ]?.mails)}</ul>
                <Typography className={classes.cardTitleMini}>{t('Address')}</Typography>
                <ul>{generateContent(location[ activeButton ]?.addresses)}</ul>
              </Box>
            </Box>
            <Box className={classes.mapItem}>
              <ReactMapGl
                {...options}
                mapboxAccessToken={token}
                style={{ width: '100%', height: '100%' }}
                mapStyle={styleMap}
                transitionDuration='200'
                onDrag={onChange}
                onZoom={onChange}
              >
                {
                  !!location.length
                  &&
                  location.map((e) => e.point.map((marker, i) => (
                    <Marker
                      key={i}
                      latitude={marker.latitude}
                      longitude={marker.longitude}
                      color='yellow'
                    ><Mark/></Marker>))
                  )
                }
              </ReactMapGl>
            </Box>
          </Box>
        }
      </Container>
    </Box>
  );
};

export default LocationMap;
